document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".content-slider-wrapper");

  sliders.forEach(function (sliderWrapper) {
    const slider = sliderWrapper.querySelector(".content-slider");
    const prevButton = sliderWrapper.querySelector(".prev-button");
    const nextButton = sliderWrapper.querySelector(".next-button");
    const sliderItems = sliderWrapper.querySelectorAll(".slider-item");

    if (!slider || !prevButton || !nextButton || sliderItems.length === 0) {
      console.warn(
        "Slider elements not found in one of the wrappers. Skipping this slider."
      );
      return;
    }

    let startX = 0;
    let endX = 0;
    let currentIndex = 0;
    let itemsPerView = getItemsPerView();

    function getItemsPerView() {
      if (window.innerWidth <= 768) {
        return 1;
      } else if (window.innerWidth <= 1024) {
        return 2;
      } else {
        return 3;
      }
    }

    function updateSliderPosition() {
      const itemWidth =
        sliderItems[0].offsetWidth +
        parseFloat(getComputedStyle(sliderItems[0]).marginLeft) * 2;
      const translateX = currentIndex * itemWidth;
      slider.style.transform = `translateX(-${translateX}px)`;
    }

    function showNext() {
      const maxIndex = Math.max(sliderItems.length - itemsPerView, 0);
      currentIndex += itemsPerView;
      if (currentIndex > maxIndex) {
        currentIndex = 0;
      }
      updateSliderPosition();
    }

    function showPrev() {
      const maxIndex = Math.max(sliderItems.length - itemsPerView, 0);
      currentIndex -= itemsPerView;
      if (currentIndex < 0) {
        currentIndex = maxIndex;
      }
      updateSliderPosition();
    }

    // Swipe Handling
    slider.addEventListener(
      "touchstart",
      function (e) {
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );

    slider.addEventListener(
      "touchmove",
      function (e) {
        endX = e.touches[0].clientX;
      },
      { passive: true }
    );

    slider.addEventListener("touchend", function () {
      const diffX = startX - endX;
      const swipeThreshold = 50;
      if (Math.abs(diffX) > swipeThreshold) {
        if (diffX > 0) {
          showNext();
        } else {
          showPrev();
        }
      }
    });

    // Button Events
    nextButton.addEventListener("click", function () {
      if (getItemsPerView() > 1) {
        showPrev();
      } else {
        showNext();
      }
    });

    prevButton.addEventListener("click", function () {
      if (getItemsPerView() > 1) {
        showNext();
      } else {
        showPrev();
      }
    });

    // Viewport-Resize Handling
    window.addEventListener("resize", () => {
      const newItemsPerView = getItemsPerView();
      if (newItemsPerView !== itemsPerView) {
        itemsPerView = newItemsPerView;
        currentIndex = 0;
      }
      updateSliderPosition();
    });

    updateSliderPosition();
  });
});
